export const splitByUppercase = (str: string) => {
  return str.split(/(?=[A-Z])/);
};
